import clsx from "clsx";

export const SectionTitle: React.FC<{
  title: string;
  subtitle: string;
  linebreak?: boolean;
}> = ({ title, subtitle, linebreak = false }) => (
  <div className="mb-10 text-center md:mb-16">
    <h3 className="mb-2 font-serif text-[28px] font-bold leading-normal text-dm-brand-blue-600 md:text-[40px]">
      {title}
    </h3>
    <h4 className={clsx("text-lg md:text-2xl", linebreak && "max-w-[650px]")}>
      {subtitle}
    </h4>
  </div>
);
